import { Link } from "gatsby"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import React from "react"
import { getBgColor, Target } from "../../../utils"

type Props = {
  name: string
  ceo: string
  openDate: string
  address: string
  openingHours: string
  phone: string
  target: Target
  image: IGatsbyImageData
  mapLink: string
}

const Info: React.VFC<Props> = ({
  name,
  ceo,
  openDate,
  address,
  openingHours,
  phone,
  target,
  image,
  mapLink,
}) => {
  const data = [
    { label: "施設名", value: name },
    { label: "代表者名", value: ceo },
    { label: "オープン", value: openDate },
    { label: "所在地", value: address },
    { label: "営業時間", value: openingHours },
    { label: "連絡先", value: phone },
  ]
  const isContact = (label: string) => label === "連絡先"
  const isAddress = (label: string) => label === "所在地"

  return (
    <div className="flex flex-col-reverse justify-between mt-8 md:mt-16 md:flex-row md:space-x-8">
      <ul className="mt-5 md:mt-0">
        {data.map(item => {
          return (
            <div key={item.label}>
              <li
                className="relative grid grid-cols-4 py-4 border-dashed md:py-7 border-Brown"
                key={item.label}
              >
                <div className="col-span-1">{item.label}</div>
                {!isContact(item.label) ? (
                  <div className="col-span-3 whitespace-pre-wrap">
                    {item.value}
                    {isAddress(item.label) && (
                      <a
                        href={mapLink}
                        className="block text-xs text-blue-500 underline"
                        target="_blank"
                      >
                        Googleマップで開く
                      </a>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center justify-between col-span-3">
                    <div>{item.value}</div>
                    <Link
                      to={`/${target}/contact`}
                      className={`p-2 text-xs text-white rounded ${getBgColor(
                        target
                      )}`}
                    >
                      お問い合わせ
                    </Link>
                  </div>
                )}
              </li>
              <div className="border-dash"></div>
            </div>
          )
        })}
      </ul>
      <GatsbyImage
        image={image}
        alt="building"
        className="mx-auto rounded-3xl"
      />
    </div>
  )
}

export default Info
